import Vue from 'vue'
import Router from 'vue-router'
// import index from '@/components/index'
// import paycenter from '@/components/paycenter'
// import callus from '@/components/callus'
// import paymoney from '@/components/paymoney'
// import about from '@/components/about'

Vue.use(Router)

export const constantRoutes = [
  // {
  //   path: '/',
  //   name: 'Index',
  //   component: index
  // },
  // {
  //   path: '/paycenter',
  //   name: 'Paycenter',
  //   component: paycenter
  // },
  // {
  //   path: '/callus',
  //   name: 'Callus',
  //   component: callus
  // },
  // {
  //   path: '/paymoney',
  //   name: 'Paymoney',
  //   component: paymoney
  // },
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: about
  // }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.$addRoutes = (params) => {
  router.matcher = new Router({ mode: 'history' }).matcher
  router.addRoutes(params)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js